export default __webpack_public_path__ + "static/media/logoforpdf.14828788.jpeg";